/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Sales_StatsInputs */

const vi_nav_sales_stats = /** @type {(inputs: Nav_Sales_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thống kê`)
};

/**

* @param {Nav_Sales_StatsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_sales_stats = /** @type {((inputs?: Nav_Sales_StatsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Sales_StatsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_sales_stats(inputs)
});